import { Layout, Menu } from 'antd';

import UserMenu from './UserMenu';

import logo from '../../assets/logo.svg';
import styles from './header.module.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { QrcodeOutlined } from '@ant-design/icons';

type IHeaderProps = {
    className?: string;
    noMenu?: boolean;
};

const Header = (props: IHeaderProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { noMenu } = props;

    const handleClick = (e: any) => {
        if (e.key === 'evals') {
            navigate(`/admin/evals`);
        }
    };

    return (
        <Layout.Header className={`${styles.header}`}>
            <div className={`${styles.headerInner} ${props.className}`}>
                <Link to="/">
                    <img src={logo} className={styles.logo} alt="Logo" />
                </Link>
                <div className={styles.right}>
                    <UserMenu />
                </div>
                {noMenu !== true && (
                    <Menu
                        onClick={handleClick}
                        selectedKeys={[
                            location.pathname.indexOf('/evals') >= 0
                                ? 'evals'
                                : '',
                        ]}
                        mode="horizontal"
                    >
                        <Menu.Item key="evals">
                            <QrcodeOutlined /> Evaluaciones
                        </Menu.Item>
                    </Menu>
                )}
            </div>
        </Layout.Header>
    );
};

export default Header;
